"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dompurify = _interopRequireDefault(require("dompurify"));
var _coreUtil = require("../core-util");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/*
 Copyright (c) 2018 Wells Fargo. 333 Market St., San Francisco, CA 94105 All rights reserved.
 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.
 */

/**
 * SDK Sanitization
 *
 * sanitization of HTML, CSS, SVG, and resource bundle strings
 * deep object merge
 *
 * @module core-sanitize
 *
 * @author Nathan Freeling
 * @copyright 2018 Wells Fargo, All rights reserved.
 */

/**
 * sanitizes HTML
 *
 * @param {string} data data to be sanitized
 * @param {boolean} scrubStyles flag indicating if all style tags and attributes should be removed
 * @return {string} sanitized data
 */
function sanitizeHTML(data, scrubStyles) {
  return _dompurify["default"].sanitize(data, {
    SAFE_FOR_JQUERY: true,
    FORBID_TAGS: scrubStyles ? ['style', 'img'] : ['img'],
    FORBID_ATTR: scrubStyles ? ['style'] : []
  });
}

/**
 * sanitizes SVG
 *
 * @param {string} data data to be sanitized
 * @param {boolean} scrubStyles flag indicating if all style tags and attributes should be removed
 * @return {string} sanitized data
 */
function sanitizeSVG(data, scrubStyles) {
  return _dompurify["default"].sanitize(data, {
    SAFE_FOR_JQUERY: true,
    USE_PROFILES: {
      svg: true,
      svgFilters: true
    },
    ADD_ATTR: ['role'],
    ADD_TAGS: ['use'],
    FORBID_TAGS: scrubStyles ? ['style'] : [],
    FORBID_ATTR: scrubStyles ? ['style'] : []
  });
}

/**
 * sanitizes CSS
 *
 * @param {string} data data to be sanitized
 * @return {string} sanitized data
 */
function sanitizeCSS(data) {
  return _dompurify["default"].sanitize(data, {
    SAFE_FOR_JQUERY: true
  });
}

/**
 * sanitizes Resource String
 *
 * @param {string} data data to be sanitized
 * @return {string} sanitized data
 */
function sanitizeResourceString(data) {
  return _dompurify["default"].sanitize(data, {
    SAFE_FOR_JQUERY: true,
    ALLOWED_TAGS: ['p', 'div', 'b', 'i', 'em', 'strong', 'ul', 'li', 'a', 'span', 'sup', 'br'],
    ALLOWED_ATTR: ['class', 'id', 'href']
  });
}

/**
 * sanitizes string, removing all markup
 *
 * @param {string} data data to be sanitized
 * @return {string} sanitized data
 */
function sanitizeAll(data) {
  return _dompurify["default"].sanitize(data, {
    ALLOWED_TAGS: []
  });
}

/**
 * sanitizes the provided object
 */
var sanitizeObject = (0, _coreUtil.stringFormatter)(sanitizeHTML);

/**
 * sanitizes string, removing all HTTP request/response splitting chars
 * @param {string} data
 * @return {string} sanitized data
 */
function sanitizeHeader(data) {
  if (!data) {
    return '';
  }
  return data.replace(/[\r\n=:]/gi, '');
}
var _default = exports["default"] = {
  sanitizeHTML: sanitizeHTML,
  sanitizeSVG: sanitizeSVG,
  sanitizeCSS: sanitizeCSS,
  sanitizeResourceString: sanitizeResourceString,
  sanitizeAll: sanitizeAll,
  sanitizeObject: sanitizeObject,
  sanitizeHeader: sanitizeHeader
};
//# sourceMappingURL=index.js.map